import { render, staticRenderFns } from "./message.vue?vue&type=template&id=03d89170"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports